import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SingleDonutGraphConfigurations } from '../../tools/single-donut-with-image/single-donut-with-image-models';
import {KlaHttpService} from "../../tools/services/kla.http.service";
import * as d3 from 'd3';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-single-donut',
  templateUrl: './single-donut.component.html',
  styleUrls: ['./single-donut.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class SingleDonutComponent implements OnInit{
  @Input()
  public config: SingleDonutGraphConfigurations;

  public imagePath: string;

  @ViewChild('singleDonut', {static: true}) private chartContainer: ElementRef;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    if(this.config.data)
    this.createChart();
  }

  @Input('width')
  set setWidth(width: number) {
    this.config.width = width;
  this.ngOnInit();
  }

  createViewPort(width: number, height: number) {
    d3.select(this.chartContainer.nativeElement).selectAll(".single-donut-graph").remove();

    return d3.select(this.chartContainer.nativeElement)
      .append('svg')
      .attr('class', 'pie single-donut-graph')
      .attr('width', width)
      .attr('height', width)
      .attr("viewBox", "0 0 408 408")
      .append('g')
      .attr('transform', 'translate(' + (10 + (width / 2)) + ',' + (10 + (height / 2)) + ')')
  }

  createChart() {
    var data = this.config.data;

    let width = this.config.width;
    let height = this.config.height;
    let thickness = this.config.thickness;

    let radius = Math.min(width, height) / 2;

    let pie: any = d3.pie<any>()
      .value(function (d) { return d.value; })
      .sort(null);

    let view = this.createViewPort(width, height);
    let cordinates = this.createOuterDonut(view, pie(data), radius, thickness);

    this.imagePath = this.httpService.getImagePath(this.config.image, radius*2);
    this.addImage(view, radius*2, height, thickness);
    let mask = this.createMask(cordinates);

    mask.forEach(item =>{
      this.hideImage(view, item, radius, thickness);
    })
  }
  createOuterDonut(view, data, radius, thickness) {
    let that = this;
    let cordinates = [];

    let arc = d3.arc<any>()
      .innerRadius(radius - thickness)
      .outerRadius(radius);

    let path = view.selectAll('path')
      .data(data)
      .enter()
      .append("g")
      .attr("class", "parent-donut")
      .append('path')
      .attr('d', arc)
      .attr('fill', d => d.data.color)
      .each(function(d){
        cordinates.push(d);
      });
      return cordinates;
  }

  hideImage(view, mask, radius, thickness) {
    var arcline = d3.arc<any>()
      .innerRadius(radius - thickness )
      .outerRadius(radius)
      .startAngle(mask.startAngle)
      .endAngle(mask.endAngle);

    view.append("g")
      .attr("class", "selected-line")
      .append('path')
      .attr('d', arcline)
      .attr('fill', mask.color)
  }

  createMask(data){
    let startAngle = Math.PI / 2;
    let endAngle = startAngle * 3;
    let maskData = [];
    data.forEach(element => {
      let startCustom = 0, endCustom = 0;
      if(element.startAngle < startAngle && element.endAngle > startAngle){
        startCustom = startAngle;
      }
      if(element.startAngle >= startAngle && element.startAngle < endAngle){
        startCustom = element.startAngle;
      }
      if(element.endAngle > endAngle && element.startAngle < endAngle){
        endCustom = endAngle;
      }
      if(element.endAngle <= endAngle && element.endAngle > startAngle){
        endCustom = element.endAngle;
      }
      if(startAngle != 0 && endAngle != 0){
        maskData.push({
          startAngle: startCustom,
          endAngle: endCustom,
          color: element.data.color
        });
      }
    });
    return maskData;
  }
  addImage(view, width, height, thickness)  {
    let imageWidth = width - (thickness*2);
    let imageY = (thickness*2) - height;
    let imageX = -Math.abs(imageWidth/2);
    view.append("image")
      .attr("id", "bg")
      .attr("xlink:href", this.imagePath)
      .attr("x", imageX)
      .attr("y", imageY)
      .attr("width", imageWidth)
      .attr("height", height);
  }

}
